import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';

import { ClientRoutingModule } from './client-routing.module';
import { ClientLayoutComponent } from '../layout/client-layout/client-layout.component';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { SharedModule } from "../shared/shared.module";
import { ProductComponent } from './pages/product/product.component';
import { ProductDetailComponent } from './pages/product/product-detail/product-detail.component';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './pages/login/login.component';


@NgModule({
  declarations: [
    ClientLayoutComponent,
    HomeComponent,
    AboutComponent,
    ProductComponent,
    ProductDetailComponent,
    LoginComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ClientRoutingModule,
    SharedModule,
    NgbPagination,
],
  providers: [Title, Meta],
})
export class ClientModule {}
